import axios from "axios";
import { config_headers, servicelist, URL_API } from "../Config";

export const pSupervisorReport2_Info = async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();

            await axios.post(URL_API(`${servicelist.SupervisorService}p_supervisor_report_2_info`), body, authorization).then((res) => {
                resolve(res);
            });
        } catch (err) {
            reject(err);
        } finally {
        }
    });
};

export const pSupervisorReport2_Update = async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            await axios.post(URL_API(`${servicelist.SupervisorService}p_supervisor_report_2_update`), body, authorization).then((res) => {
                resolve(res);
            });
        } catch (err) {
            reject(err);
        } finally {
        }
    });
};
